export class SectorDepartmentModel
{
    DepartmentIDs:number[]=[]
    SectorID:number;

}